import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import NexusCodeApp from "./NexusCodeApp";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<NexusCodeApp />);
